// ```calc blocks: CalcPad's scratchpad in a note. Each line of the block is
// evaluated, the variables of one line seen by the lines under it, and its
// result shown to the right of it:
//
//   ```calc
//   rent = 1.2k
//   bills = 180
//   rent + bills          1,380
//   10% off rent          1,080
//   ```
//
// Lines that are empty, comments (`#`) or errors show nothing.
import {
  type Fenced,
  findFenced,
} from '@/app/fence';
import {
  evaluate,
  type LineResult,
} from './evaluate';

export const findCalcs = (body: string): Fenced[] => findFenced(body, 'calc');

const decimalPlaces = 2;

const numbers = new Intl.NumberFormat('en', {
  maximumFractionDigits: decimalPlaces,
});

// what's shown for a line: too small or large a number in scientific
// notation, 6.62e-34 or 1.5e+21, any other rounded, with thousands separated
export const formatResult = (result: LineResult): string => {
  if (result.kind !== 'value') return '';
  const { value } = result;
  const magnitude = Math.abs(value);
  const roundsToZero = magnitude !== 0
    && magnitude < 0.5 * Math.pow(10, -decimalPlaces);
  return roundsToZero || (magnitude >= 1e21 && magnitude !== Infinity)
    ? value.toExponential(decimalPlaces).replace(/\.?0+e/, 'e')
    : numbers.format(value);
};

// one per line of the text
export const results = (text: string): string[] =>
  evaluate(text).map(formatResult);
